import { render } from "./AuthModule.vue?vue&type=template&id=cc635438&ts=true"
import script from "./AuthModule.vue?vue&type=script&lang=ts"
export * from "./AuthModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__